import { render, staticRenderFns } from "./CurriculumVitae.vue?vue&type=template&id=22f01168&"
import script from "./CurriculumVitae.vue?vue&type=script&lang=js&"
export * from "./CurriculumVitae.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports